import { mixpanelAnalytics } from '@/app/providers/mixpanel/BaseTracker'
import { MixpanelEvent, MixpanelCounter } from '@/types'
import type { Wallet } from '@injectivelabs/wallet-base'

export const trackConnectClicked = () => {
  const client = mixpanelAnalytics.getMixpanelClient()

  if (!client) {
    return
  }

  mixpanelAnalytics.track(MixpanelEvent.ConnectClicked, {})
  mixpanelAnalytics.increment(MixpanelCounter.ConnectClicked)
}

export const trackLogin = ({
  address,
  wallet
}: {
  wallet: Wallet
  address: string
}) => {
  const client = mixpanelAnalytics.getMixpanelClient()

  if (!client) {
    return
  }

  client.identify(address)

  mixpanelAnalytics.track(MixpanelEvent.Login, {
    wallet,
    address
  })

  client.people.increment({ Login: 1, [wallet]: 1 })
  client.people.set({ wallet })
}

export const trackWalletAddress = (injectiveAddress: string) => {
  const client = mixpanelAnalytics.getMixpanelClient()

  if (!client) {
    return
  }

  client.identify(injectiveAddress)
}

export const trackLogout = () => {
  const client = mixpanelAnalytics.getMixpanelClient()

  if (!client) {
    return
  }

  client.reset()
}
